import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../environments/environment';
import { ImageAnnotation, ImageAnnotationList } from '../models/image-annotation';

@Injectable()
export class ImageAnnotationService {
    private httpHeaders: HttpHeaders;
    private imageAnnotations$: BehaviorSubject<ImageAnnotationList>;
    private imageAnnotation$: BehaviorSubject<ImageAnnotation>;

    constructor(private http: HttpClient) {
        this.init();
    }

    init(): void {
        /* Common headers */
        this.httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': environment.apiKey,
            'X-PhiBor-App': environment.phiborApp
        });

        /* Observables on annotation data */
        this.imageAnnotations$ = new BehaviorSubject<ImageAnnotationList>([]);
        this.imageAnnotation$ = new BehaviorSubject<ImageAnnotation>(<ImageAnnotation>{});
    }

    /* Image annotations API call */
    private loadImageAnnotations(imgId: string): void {
        this.http.get<ImageAnnotationList>(
            environment.endpoints.res + '/images/' + imgId + '/annotations',
            {
                headers: this.httpHeaders,
                params: new HttpParams()
                    .set('fields', 'pkid,image,content_text_norm,fkidmanuscripts,fkidannotation_types,sorting,version')
                    .set('sort', 'sorting,pkid')
            })
            .subscribe(
                response => this.imageAnnotations$.next(response),
                error => this.imageAnnotations$.error(error)
            );
    }

    /* Single image annotation API call */
    private loadImageAnnotation(imgId: string, annId: number): void {
        this.http.get<ImageAnnotation>(
            environment.endpoints.res + '/images/' + imgId + '/annotations/' + annId,
            {
                headers: this.httpHeaders,
                params: new HttpParams()
            })
            .subscribe(
                response => this.imageAnnotation$.next(response),
                error => this.imageAnnotation$.error(error)
            );
    }

    /* Get image annotation list */
    getImageAnnotations(imgId: string): Observable<ImageAnnotationList> {
        this.loadImageAnnotations(imgId);
        return this.imageAnnotations$.asObservable();
    }

    /* Get single image annotation main data */
    getImageAnnotation(imgId: string, annId: number): Observable<ImageAnnotation> {
        this.loadImageAnnotation(imgId, annId);
        return this.imageAnnotation$.asObservable();
    }

}



// WEBPACK FOOTER //
// ./src/app/services/image-annotation.service.ts